 // Scripting to handle tabs interaction
 (function ($) {

   //Stop propagation on linked card anchor clicks
   $(document).on('click', '.card.linked-card a', function (e) {
     e.preventDefault();
   });
   //Capture card clicks outside of the anchors
   $(document).on('click', '.card.linked-card', function (e) {
     let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');
     let $anchor = $card.find('a').first();
     if ($anchor) {
       handleCardAnchorClick($anchor);
     }

   });


   //Stop propagation on linked post anchor clicks
   $(document).on('click', '.post.linked-post a', function (e) {
     e.preventDefault();
   });
   //Capture post clicks outside of the anchors
   $(document).on('click', '.post.linked-post', function (e) {
     let $post = $(this).hasClass('post') ? $(this) : $(this).parents('.post');
     let $anchor = $post.find('a').first();
     if ($anchor) {
       handleCardAnchorClick($anchor);
     }

   });
   

    //Centralized handling of the card clicks
    function handleCardAnchorClick($anchor) {
      //Modals have to trigger a special event to avoid recursive clicking
      if ($anchor.hasClass('open-popup-link')) {
        $anchor.trigger('modalclick');
      }
      else if ($anchor.attr('target') == '_blank') {
        window.open($anchor.attr('href'));
      }
      else {
        window.location = $anchor.attr('href');
      }
    }
    
 })(jQuery);
